/** @format */

import React from 'react';
import GridItem from './GridItem';

export default function AccessStations({
  text: { heading, items },
  displayHeading = true
}) {
  return (
    <div className='dashboard-cards-body-section'>
      {displayHeading && (
        <div className='dashboard-main-heading'>
          <h2>{heading}</h2>
        </div>
      )}
      <div className='dashboard-accessstation-grid'>
        {items.map((item, index) => (
          <GridItem key={index} item={item} index={index} />
        ))}
      </div>
    </div>
  );
}
